import { render, staticRenderFns } from "./IcoPoints.vue?vue&type=template&id=bbcb15c8"
import script from "./IcoPoints.vue?vue&type=script&lang=js"
export * from "./IcoPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports